// This is a component to pass as `nav` prop for SideNavPageLayout when the
// navigation is loading.
import {StyleSheet} from "aphrodite";
import * as React from "react";

import {semanticColor, spacing} from "@khanacademy/wonder-blocks-tokens";
import {ShimmerRectangle} from "@khan/component-shimmer";

function NavLoading(): React.ReactElement {
    return (
        <div>
            {Array.from({length: 6}, (_, i) => (
                <ShimmerRectangle style={styles.skeleton} key={i} />
            ))}
        </div>
    );
}

const styles = StyleSheet.create({
    skeleton: {
        height: 20,
        borderRadius: 2,
        background: semanticColor.core.background.neutral.subtle,
        marginInlineStart: spacing.large_24,
        marginInlineEnd: spacing.large_24,
        marginBlockStart: spacing.medium_16,
        ":first-child": {
            // Left navigation container already has 12px top padding.
            // We only want 22px top padding so we set this as 10px here.
            marginTop: 10,
        },
        ":last-child": {
            marginBottom: spacing.medium_16,
        },
    },
});

export default NavLoading;
